<template>
  <b-field grouped>
    <b-field
      expanded
      :label="$t('integration.labels.integration')"
    >
      <b-select
        v-model="integration_id"
        expanded
        :disabled="readonly"
        @update:modelValue="updateIntegrationId"
      >
        <option
          :key="null"
          :value="null"
        />
        <option
          v-for="integration in integrations"
          :key="integration.id"
          :value="integration.id"
        >
          {{ integration.attributes.name }}
        </option>
      </b-select>
    </b-field>
    <b-field
      expanded
      :label="$t('integration.labels.integrationOID')"
    >
      <div class="field">
        <input
          v-model.trim="integration_oid"
          class="input"
          :disabled="integration_id === null || readonly"
          :readonly="readonly"
          type="text"
          @keyup="updateIntegrationOid"
        />
      </div>
    </b-field>
  </b-field>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SelectIntegration',

  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
    },
  },

  emits: ['update:modelValue'],

  computed: {
    ...mapGetters(['integrations']),

    integration_id: {
      get() {
        return this.modelValue.attributes.integration_id;
      },
      set(value) {
        this.updateModelValue('integration_id', value);
      },
    },

    integration_oid: {
      get() {
        return this.modelValue.attributes.integration_oid;
      },
      set(value) {
        this.updateModelValue('integration_oid', value);
      },
    },
  },

  methods: {
    updateModelValue(key, value) {
      const updatedModel = { ...this.modelValue };
      updatedModel.attributes = {
        ...updatedModel.attributes,
        [key]: value,
      };
      if (key === 'integration_id' && value === null) updatedModel.attributes.integration_oid = null;
      this.$emit('update:modelValue', updatedModel);
    },

    updateIntegrationId(value) {
      this.integration_id = value;
    },

    updateIntegrationOid() {
      this.$emit('update:modelValue', this.modelValue);
    },
  },
};
</script>
